export const isAuthenticated = () =>
  localStorage.getItem('@token/ceos') !== null
